module.exports = {
  common: {
    text1: "输入手机号",
    text2: "输入邮箱账号",
    text3: "请输入验证码",
    text4: "输入邀请码",
    text5: "输入密码",
    text6: "请再次输入密码",
    text7: "立即注册",
    text8: "使用手机号",
    text9: "使用邮箱",
    text10: "下载APK",
    text11: "复制链接",
    text12: "获取验证码",
    text13: "请填写数字大小写字母组合且不少于8位的密码",
    text14: "两次密码输入不一致, 请重新输入",
    text15: "注册成功",
    text16: "请核对页面参数",
    text17: "验证码发送成功!",
    text18: "请输入正确",
    text19: "手机号",
    text20: "邮箱号",
    text21: "文本已复制到剪贴板",
  },
};
